import {
	Action,
	Dispatch,
} from 'redux';
// Import action type enumeration.
import ActionType from '@app/redux/actions/types';
import { AppMode } from '@app/enumerations';

// Add App Mode Action.

interface AddAppModeParameters {
	appMode: AppMode;
}

type AddAppModeAction = Action & AddAppModeParameters;

const addAppModeAction: (params: AddAppModeParameters) =>
	AddAppModeAction = (params: AddAppModeParameters) => ({
		...params,
		type: ActionType.ADD_APP_MODE
	});

const addAppMode = (params: AddAppModeParameters) =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch<AddAppModeAction>(addAppModeAction(params));
	};


// Remove App Modes Action.

interface RemoveAppModesParameters {
	appModes: AppMode[];
};

type RemoveAppModesAction = Action & RemoveAppModesParameters;

const removeAppModesAction: (params: RemoveAppModesParameters) =>
	RemoveAppModesAction = (params: RemoveAppModesParameters) => ({
		...params,
		type: ActionType.REMOVE_APP_MODES
	});

const removeAppModes = (params: RemoveAppModesParameters) =>
	async (dispatch: Dispatch): Promise<void> => {
		dispatch<RemoveAppModesAction>(removeAppModesAction(params));
	};


// Export actions.
export {
	AddAppModeAction,
	RemoveAppModesAction,
};

// Export action methods.
export {
	addAppMode,
	removeAppModes,
};

// Export action parameters.
export {
	AddAppModeParameters,
	RemoveAppModesParameters,
};

// Export action factories.
export {
	addAppModeAction,
	removeAppModesAction,
};